import { useEffect, useState } from "react";
import httpclient from "../Utils";
import useTokenRefresh from "./useTokenRefresh";
import { useApiErrorHandler } from "./useApiErrorHandler";

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [userBranches, setUserBranches] = useState([]);
  const [userDevices, setUserDevices] = useState([]);

  const [loading, setLoading] = useState(false);

  const { getTokenRefreshed: refresh } = useTokenRefresh();
  const handleApiError = useApiErrorHandler();

  const getUsers = async () => {
    setLoading(true);
    const API_URL = "users/all";

    try {
      const res = await httpclient.get(API_URL);
      const { data } = res;

      if (data.status === 200) {
        setUsers(data.data);
        setUserRoles(data.roles);
        setUserBranches(data.branches);
        setUserDevices(data.devices);
      }
    } catch (error) {
      // handleApiError(error); // optionally refresh if 401
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  console.log(userDevices, "devices");

  return { users, userRoles, userBranches, userDevices, loading };
};
